import Aos from "aos";

jQuery( document ).ready(function($) {
    $('.search-toggle').on('click', function(e){
        $('.search-wrapper').toggleClass('open');
        $('#header .menu').removeClass('open');
    })
    $('.menu-toggle').on('click', function(e){
        $('#header .menu').toggleClass('open');
        $('.search-wrapper').removeClass('open');
    })

    Aos.init();
});